import * as action from "constants/productConstants";
import axios from "axios";
import config from "utils/config";
import { IRating } from "containers/ListingDetailPage/ListingCarDetailPage";
import { SingleItem } from "types/interfaces";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import { RentripsURL } from "utils/request";

export const getCategoryCount = () => async (dispatch: any) => {
  try {
    dispatch({ type: action.PRODUCT_CATEGORY_COUNT_REQUEST });
    const {
      data: { data },
    } = await axios.get(RentripsURL +`/api/product/category`);

    dispatch({ type: action.PRODUCT_CATEGORY_COUNT_SUCCESS, payload: data });
  } catch (error: any) {
    dispatch({
      type: action.PRODUCT_CATEGORY_COUNT_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getProducts = (category: string) => async (dispatch: any) => {
  try {
    dispatch({ type: action.PRODUCT_MANY_REQUEST });

    const { data } = await axios.get(RentripsURL +`/api/product/${category}`);

    dispatch({ type: action.PRODUCT_MANY_REQUEST_SUCCESS, payload: data });
    // const {data} = axios.get
  } catch (error: any) {
    dispatch({
      type: action.PRODUCT_MANY_REQUEST_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteProduct =
  (id: string) => async (dispatch: any, getState: any) => {
    const { token } = getState().userInfo.userInfo;

    logging(token, {
      category: "product",
      action: "delete",
      target: id,
    });

    try {
      dispatch({ type: action.PRODUCT_DELETE_REQUEST });

      const { data } = await axios.delete(RentripsURL +`/api/product/${id}`, config(token));

      if (data) {
        setTimeout(() => {
          dispatch({ type: action.PRODUCT_DELETE_SUCCESS });
        }, 1000);
      }

      eventAnalytic({
        category: "Product",
        action: "Delete product",
        label: id,
      });
    } catch (error: any) {
      eventAnalytic({
        category: "Product",
        action: "Delete product failed",
        label: id,
      });
      dispatch({
        type: action.PRODUCT_DELETE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getSingleProduct =
  (id: string) => async (dispatch: any, getState: any) => {
    const { token } = getState().userInfo.userInfo || "";

    logging(token, {
      category: "product",
      action: "page",
      target: id,
    });

    try {
      eventAnalytic({
        category: "Product",
        action: "Product Page",
        label: id,
      });

      dispatch({ type: action.PRODUCT_SINGLE_REQUEST });

      const { data }: { data: SingleItem } = await axios.get(
        RentripsURL +`/api/product/${id}`
      );

      dispatch({ type: action.PRODUCT_SINGLE_REQUEST_SUCCESS, payload: data });
    } catch (error: any) {
      window.location.href = "/404";
      eventAnalytic({
        category: "Product",
        action: "Product Page Failed",
        label: id,
      });

      dispatch({
        type: action.PRODUCT_SINGLE_REQUEST_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

/**
 * Get all product user has uploaded and show it on profile
 *
 * @method GET
 * @param {String} id
 */
export const getUserProduct = (id: string) => async (dispatch: any) => {
  try {
    dispatch({});

    dispatch({});
  } catch (error: any) {
    dispatch({});
  }
};

// Kalau user mau search product nanti ini yang ditampilin.
// Nantinya pakai regex buat nyari sesuai namanya dia
// Kalau misalkan nama ga ketemu, lempar ke kategori, tapi kasi warning, untuk nama yang dicari tidak ketemu
// Method: GET
// Params: keyword
export const searchProduct = (keyword: string) => async (dispatch: any) => {
  try {
    dispatch({});

    dispatch({});
  } catch (error: any) {
    dispatch({});
  }
};

// Filter product sesuai kemauan user, mulai dari harga ke tipe ke yang lain2
export const filterProduct = () => async (dispatch: any) => {
  try {
    dispatch({});

    dispatch({});
  } catch (error: any) {
    dispatch({});
  }
};

// Dapetin semua product yang dilike sama si orang itu
// METHOD: GET
export const getLikedProduct = () => async (dispatch: any, getState: any) => {
  try {
    dispatch({ type: action.PRODUCT_LIKE_REQUEST });

    const { token } = getState().userInfo.userInfo;

    const { data } = await axios.get(RentripsURL +"/api/user/like", config(token));

    dispatch({ type: action.PRODUCT_LIKE_SUCCESS, payload: data });

    localStorage.setItem("likedProduct", JSON.stringify(data));
  } catch (error: any) {
    dispatch({
      type: action.PRODUCT_SINGLE_REQUEST_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

/**
 * Get all user's liked products
 *
 * @method PATCH
 * @param {String} productId
 * @returns
 */

export const likedProduct =
  (productId: string) => async (dispatch: any, getState: any) => {
    const { token } = getState().userInfo.userInfo;

    logging(token, {
      category: "product",
      action: "like",
      target: productId,
    });
    try {
      const { data } = await axios.patch(
        RentripsURL + "/api/user/like",
        { productId },
        config(token)
      );

      dispatch({ type: action.PRODUCT_LIKE_SUCCESS, payload: data });

      eventAnalytic({
        category: "product",
        action: "like product",
        label: productId,
      });

      localStorage.setItem("likedProduct", JSON.stringify(data));
    } catch (error: any) {
      eventAnalytic({
        category: "product",
        action: "like product failed",
        label: productId,
      });
      dispatch({
        type: action.PRODUCT_SINGLE_REQUEST_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const reviewProduct =
  (rating: IRating, productId: string) =>
  async (dispatch: any, getState: any) => {
    const { token, id, name, avatar } = getState().userInfo.userInfo;

    logging(token, {
      category: "product",
      action: "review",
      target: productId,
    });

    try {
      dispatch({ type: action.PRODUCT_REVIEW_REQUEST });

      const { singleProduct }: { singleProduct: SingleItem } =
        getState().productSingle;

      const { data } = await axios.post(
        RentripsURL +`/api/product/review/${productId}`,
        rating,
        config(token)
      );

      const newReview = {
        _id: data._id,
        authorId: data.authorId,
        stars: data.stars,
        message: data.message,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt,
        author: { _id: id, avatar, displayName: name },
      };

      singleProduct.status.reviews.unshift(newReview);

      dispatch({
        type: action.PRODUCT_REVIEW_SUCCESS,
        payload: singleProduct,
      });

      dispatch({
        type: action.PRODUCT_SINGLE_REQUEST_SUCCESS,
        payload: singleProduct,
      });
    } catch (error: any) {
      dispatch({
        type: action.PRODUCT_REVIEW_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      setTimeout(() => {
        dispatch({ type: action.PRODUCT_REVIEW_RESET });
      }, 4000);
    }
  };
